import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider  } from "react-router-dom";
import Root from "./routes/root";
import { YearlyList } from 'components/YearlyList';
import { Ufo50List } from 'components/Ufo50';
import { GwenFullList } from 'components/GwenFullList';
import { GwenGOTYList } from 'components/GwenGOTYList';
import { OtherList } from 'components/OtherList';
import { GameBuilds } from 'components/GameBuilds';

const router = createBrowserRouter([
    {
        path: "/builds",
        element: <GameBuilds />,
    },
    {
        path: "/",
        element: <Root />,
        children: [
            {
                path: "/YearlyList/:year",
                element: <YearlyList />
            },
            {
                path: "/Ufo50",
                element: <Ufo50List />
            },
            {
                path: "/GwenFullList",
                element: <GwenFullList />
            },
            {
                path: "/GwenGOTYList/:year",
                element: <GwenGOTYList />
            },
            {
                path: "/OtherList/:listType",
                element: <OtherList />
            },
            {
                path: "/",
                element: <App />
            }
        ],
    },
]);

const container = document.getElementById('root');
const root = createRoot(container)
root.render(<RouterProvider router={router} />);